export const SALES_QUOTE = 'SQ';
export const SALES_ORDER = 'SO';
